import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import styles from './styles.module.scss';

type Props = {
    item: DropdownItemData;
    onSelect: (item: DropdownItemData) => void;
};

export const AnalysisOption = ({item, onSelect}: Props) => {
    const handleClick = () => {
        onSelect(item);
    };

    return (
        <Flex
            justifyContent="flex-start"
            alignItems="center"
            componentClasses={styles.analysisOptionContainer}
            onClick={handleClick}
        >
            <Text skin="paragraph-2" componentClasses={styles.analysisOption}>
                {item.label}
            </Text>
        </Flex>
    );
};
